module.exports = __webpack_public_path__ + "img/oficina-pasaje.e349e293.jpg";